import React from "react";
import { useLang } from "../../context/LangContext";
import { useCMS } from "../../context/CMSContext";
import { SITE_CONFIG } from "../../config/siteConfig";
import { useInView } from "../../hooks/useInView";
import SectionHeader from "../common/SectionHeader";
import { fonts } from "../../styles/tokens";
import styles from "./Categories.module.css";

function Categories() {
  const { t, lang = "en" } = useLang();
  const { cms } = useCMS();
  const [ref, visible] = useInView();

  const cmsCats = cms?.categories?.items;

  const cats =
    cmsCats && cmsCats.length > 0
      ? cmsCats.map((c) => ({ id: c.id }))
      : SITE_CONFIG.categories;

  const names =
    cmsCats && cmsCats.length > 0
      ? Object.fromEntries(
          cmsCats.map((c) => [c.id, c[`label_${lang}`] || c.label_en || c.id]),
        )
      : t.categories.names;

  return (
    <section id="categories" className={styles.section} ref={ref}>
      <div className="container">
        <SectionHeader
          label={t.categories.label}
          heading={t.categories.heading}
          subheading={t.categories.subheading}
        />
        <div className={styles.grid}>
          {cats.map((cat, i) => (
            <a
              key={cat.id}
              href={`#cat-${cat.id}`}
              className={`${styles.chip} ${visible ? styles.visible : ""}`}
              style={{ transitionDelay: `${i * 35}ms` }}
            >
              <span
                style={{
                  fontFamily: fonts.body,
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                {names[cat.id]}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Categories;
